var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dash"},[_c('Menu',[_c('transition',{attrs:{"name":"page-transition","mode":"out-in"}},[_c('router-view',{key:_vm.$route.fullPath,on:{"callModal":_vm.callModal}})],1)],1),_c('div')],1)}
var staticRenderFns = []

export { render, staticRenderFns }